import React, { useState, useEffect } from "react";
import "./styles/projects.css";
import { FaCode, FaGraduationCap, FaFolderOpen } from "react-icons/fa";
import {
  SiJavascript,
  SiC,
  SiNodedotjs,
  SiReact,
  SiPostgresql,
  SiPython,
  SiPytorch,
  SiExpress,
  SiMongodb,
  SiGit,
  SiGithub,
  SiDocker,
  SiVsco,
  SiTypescript,
} from "react-icons/si";


const projects = [
  {
    image: "/projects/project-4.jpg",
    type: "backend",
    title: "Formswift-Form-Submission-Application",
    description:
      "FormSwift is a Dockerized backend service that handles form submissions, persists booking data to MongoDB, and sends email notifications. It is designed to integrate with any frontend and can be started locally with a single Docker Compose command.",
    details:
      "Backend form submission & booking service",
    tech: ["JavaScript", "Node.js", "Docker"],
    link: "#",
    github: "#",
  },
  { 
    image: "/projects/project-5.webp",
    status: "wip",
    title: "LiegeHost-Hosting-Reseller-Application",
    description:
      "LiegeHost is a backend-focused hosting and domain reseller platform built on top of WHMCS and eNom APIs. The project is designed to automate domain registration, DNS management, hosting provisioning, billing, and client lifecycle management through a unified internal system. The project is currently under active development.",
    details:
      "whmcs & eNOM client hosting reseller.",
    tech: ["React", "Express", "PostgreSQL", "Node.js"],
    link: "#",
    github: "#",
  },
  {
    image: "/projects/project-6.jpg",
    type: "backend",
    status: "wip",
    title: "Real-Time-Basketball-Scoreboard-System",
    description:
      "The Real-Time Basketball Scoreboard System is a comprehensive tool designed to manage live game scores, fouls, and timing with precision. It features real-time updates, persistent timing logs, and dynamic team management, making it ideal for sports applications, event tracking, or educational projects",
    details:
      "This project aims to deliver an accurate, synchronized, and flexible scoreboard solution.",
    tech: ["C"],
    link: "#",
    github: "#",
  },
];

const sites = [
  {
    url: "celebrationspride.com",
    image: "/sites/site1.png",
  },
  {
    url: "drphysioclinic.org",
    image: "/sites/site2.png",
  },
  {
    url: "builttogetherfoundation.org",
    image: "/sites/site3.png",
  },
  {
    url: "ebenezerinn.com",
    image: "/sites/site4.png",
  },
  {
    url: "trekapp.com",
    image: "/sites/site5.png",
  },
];

const techIcons = {
  JavaScript: <SiJavascript />,
  "Node.js": <SiNodedotjs />,
  React: <SiReact />,
  PostgreSQL: <SiPostgresql />,
  Python: <SiPython />,
  PyTorch: <SiPytorch />,
  Express: <SiExpress />,
  Docker: <SiDocker />,
  C: <SiC />
};

const skillGroups = [
  {
    category: "Languages",
    items: [
      { name: "JavaScript", icon: <SiJavascript /> },
      { name: "TypeScript", icon: <SiTypescript /> },
      { name: "Python", icon: <SiPython /> },
    ],
  },
  {
    category: "Frameworks",
    items: [
      { name: "Node.js", icon: <SiNodedotjs /> },
      { name: "React", icon: <SiReact /> },
      { name: "Express.js", icon: <SiExpress /> },
      { name: "PyTorch", icon: <SiPytorch /> },
    ],
  },
  {
    category: "Tools",
    items: [
      { name: "PostgreSQL", icon: <SiPostgresql /> },
      { name: "MongoDB", icon: <SiMongodb /> },
      { name: "Git", icon: <SiGit /> },
      { name: "GitHub", icon: <SiGithub /> },
      { name: "Docker", icon: <SiDocker /> },
      { name: "VS Code", icon: <SiVsco /> },
    ],
  },
];

function Projects() {
  const [openProject, setOpenProject] = useState(null);

  // ESC key closes modal
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setOpenProject(null);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>    

      {/* STARFIELD */}
      <div className="stars-container">
        <div id="stars" className="star-layer"></div>
        <div id="stars2" className="star-layer"></div>
        <div id="stars3" className="star-layer"></div>
      </div>

      <section className="projects">
        <div className="projects-hero">
          <h2 className="projects-title">
            <span className="project-label">MY WORKS</span>
            <h2 className="split-title">My <span>Projects</span></h2>
          </h2>
          <p>
            Designing & developing tailored websites for businesses since 2021.
          </p>
        </div>
      </section>

      <section className="w-full py-12 px-0 bg-[var(--bg-surface)]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">

            {/* LEFT CONTENT */}
            <div>
              <span className="text-sm uppercase tracking-widest text-gray-400">
                About Me
              </span>

              <h2 className="text-4xl sm:text-5xl text-[var(--text-primary)] font-bold leading-tight mt-4 mb-6">
                Building Meaningful <br /> Digital Experiences
              </h2>

              <p className="text-[var(--text-secondary)] max-w-xl mb-8">
                I’m a creative front-end developer passionate about building modern
                and responsive web experiences. My journey began with a love for
                design and evolved into a deep curiosity for how the web works —
                combining logic, creativity, and clean code.
              </p>

              <p className="text-[var(--text-secondary)] max-w-xl mb-12">
                When I’m not coding, I enjoy learning new technologies, improving
                my projects, and refining user interfaces with attention to detail
                and clarity.
              </p>

              {/* WHAT DRIVES ME */}
              <h3 className="text-lg [var(--text-secondary)] font-[PT_Serif] font-semibold mb-4">What Drives Me</h3>

              <div className="grid sm:grid-cols-3 gap-4">

                {/* Card 1 */}
                <div className="border rounded-xl p-4 flex flex-col gap-2 hover:shadow-sm transition">
                  <FaCode className="text-indigo-600 text-lg" />
                  <h4 className="font-semibold text-sm text-[var(--text-secondary)]">Languages</h4>
                  <p className="text-xs text-gray-500">
                    HTML, CSS, JavaScript, React, NodeJs, Embedded C/C++, Python
                  </p>
                </div>

                {/* Card 2 */}
                <div className="border rounded-xl p-4 flex flex-col gap-2 hover:shadow-sm transition">
                  <FaGraduationCap className="text-indigo-600 text-lg" />
                  <h4 className="font-semibold text-sm text-[var(--text-secondary)]">Education</h4>
                  <p className="text-xs text-gray-500">
                    Bachelor of Engineering in Computer Science
                  </p>
                </div>

                {/* Card 3 */}
                <div className="border rounded-xl p-4 flex flex-col gap-2 hover:shadow-sm transition">
                  <FaFolderOpen className="text-indigo-600 text-lg" />
                  <h4 className="font-semibold text-sm text-[var(--text-secondary)]">Projects</h4>
                  <p className="text-xs text-gray-500">
                    Built more than 10 projects
                  </p>
                </div>

              </div>
            </div>

            {/* RIGHT – BROWSER MOCKUP SLIDER */}
            <div className="flex justify-center">
              <div className="w-full max-w-md border rounded-2xl overflow-hidden shadow-sm bg-white">

                {/* Browser Bar */}
                <div className="flex items-center gap-2 px-4 py-2 bg-gray-100 border-b">
                  <span className="w-3 h-3 rounded-full bg-red-400" />
                  <span className="w-3 h-3 rounded-full bg-yellow-400" />
                  <span className="w-3 h-3 rounded-full bg-green-400" />
                  <span className="ml-4 text-xs text-gray-500 truncate">
                    {sites[activeIndex].url}
                  </span>
                </div>

                {/* Scrollable Screenshot */}
                <div className="h-[420px] overflow-y-auto">
                  <img
                    src={sites[activeIndex].image}
                    alt={sites[activeIndex].url}
                    className="w-full"
                    loading="lazy"
                  />
                </div>

                {/* Controls */}
                <div className="flex justify-center gap-2 py-3 bg-gray-50 border-t">
                  {sites.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setActiveIndex(index)}
                      className={`w-2.5 h-2.5 rounded-full transition ${
                        index === activeIndex
                          ? "bg-indigo-600"
                          : "bg-gray-300 hover:bg-gray-400"
                      }`}
                    />
                  ))}
                </div>

              </div>
            </div>

          </div>
        </div>

        <div className="projects-grid">
          {projects.map((proj, index) => (
            <div
              key={index}
              className="project-card"
              style={{ animationDelay: `${index * 0.2}s` }}
              onClick={() => setOpenProject(proj)}
            >
            {/* Badge */}
            {proj.type === "backend" && (
              <span className="project-badge backend">Backend</span>
            )}

            {/* Work in progress badge */}
            {proj.status === "wip" && (
              <span className="project-badge wip">Work in Progress</span>
            )}

            {/* Image */}
            {proj.image ? (
              <img src={proj.image} alt={proj.title} />
            ) : (
              <div className="project-placeholder">
                <span className="placeholder-icon">⚙️</span>
                <p>Backend System</p>
              </div>
            )}
              <h3>{proj.title}</h3>
              <p>{proj.description}</p>

              <div className="tech-tags">
                {proj.tech.map((t, i) => (
                  <span key={i} className="tag">
                    {techIcons[t] && (
                      <span className="tag-icon">{techIcons[t]}</span>
                    )}
                    {t}
                  </span>
                ))}
              </div>

              <a
                href={proj.link}
                className="project-link"
                onClick={(e) => e.stopPropagation()} // Prevent triggering modal
                target="_blank"
                rel="noopener noreferrer"
              >
                View Project →
              </a>
            </div>
          ))}
        </div>
      </section>
            
      <section className="skills">
        <div className="projects-hero">
          <h2 className="projects-title">
            <span className="split-title">Skills</span>
          </h2>
          <p>
            Designing & developing tailored websites for businesses since 2021.
          </p>
        </div>

        <div className="skills-grid">
          {skillGroups.map((group, index) => (
            <div
              key={index}
              className="skills-card"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <h3>{group.category}</h3>
              <div className="skills-list">
                {group.items.map((skill, i) => (
                  <div key={i} className="skill-item">
                    <span className="skill-icon">{skill.icon}</span>
                    <span className="skill-label">{skill.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* === PROJECT MODAL === */}
      {openProject && (
        <>
          <div className="modal-backdrop" onClick={() => setOpenProject(null)} />

          <div className="modal">
            <button className="modal-close" onClick={() => setOpenProject(null)}>
              ✕
            </button>

            <h2>{openProject.title}</h2>

            <p className="modal-description">{openProject.details}</p>

            <h3>Tech Used</h3>
            <div className="modal-tech">
              {openProject.tech.map((t, i) => (
                <span key={i} className="tag">
                  {techIcons[t]} {t}
                </span>
              ))}
            </div>

            <div className="modal-buttons">
              <a href={openProject.link} target="_blank" rel="noopener noreferrer">
                Live Demo
              </a>
              <a href={openProject.github} target="_blank" rel="noopener noreferrer">
                GitHub
              </a>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Projects;